
export function getExperienceTypeTitle(type: string, valor?: number): string {
  const typeMap: Record<string, string> = {
    dias_livres: 'Dias Livres',
    cartao: `Cartão multi experiências no valor de R$${valor}`,
  };

  // Se a última palavra for 'cd', coloca em uppercase
  const result = typeMap[type] || type.charAt(0).toUpperCase() + type.slice(1).replace(/_/g, ' ');
  return result.replace(/\bcd\b$/i, 'CD');
}

export function getExperienceTypeDescription(type: string, validity?: string): string {
  const typeMap: Record<string, string> = {
    dias_livres: `Os dias livres devem ser usufruídos até ${validity}`,
    cartao: `Cartão exclusivo para aquisição de esperiências (sem função de saque ou pagamento de contas).`,
  };

  return typeMap[type] || type.charAt(0) + type.slice(1).replace(/_/g, ' ');
}


export function getExperienceTypeIcon(type: string): string {
  const iconMap: Record<string, string> = {
    'dias_livres': '🏖️',
    'cartao': '💳',
  };

  return iconMap[type] || '🎯';
}
